import "./modal-form.scss";

(function () {
    if (document.querySelectorAll(".js-modal-form").length > 0) {

        const modalForm = {
            init: () => {
                modalForm.triggerModal();
            },
            triggerModal: () => {
                const buttons = document.querySelectorAll(".js-modal-trigger");

                buttons.forEach((button) => {
                    button.addEventListener("click", (e) => {
                        const id = e.target.dataset.id;
                        const root = e.target.closest(".js-modal-form");
                        let modal = root.querySelector("[data-formid='" + id + "']");

                        if (modal === null) {
                            modal = root.querySelector(".js-modal-form-block");
                        }

                        if (modal !== null) {
                            modal.style.display = "flex";

                            modal.addEventListener("click", (e) => {
                                if (e.target.classList.contains("modal-form__close") || e.target.classList.contains("js-modal-form-block")) {
                                    modal.style.display = "none";
                                }
                            });
                        }
                    })
                });
            },
        };

        modalForm.init();
    }
})();
